import PropTypes from 'prop-types';

const STANDARD_POPOVER_MAX_SIZE = 256;
const STANDARD_THUMBNAIL_IMAGE_SIZE = 64;

const getResizedImageUrl = (baseUrl, imageUrl, maxSize) => {
  if (!imageUrl || !maxSize) {
    return;
  }

  return `${baseUrl}/${maxSize}/${maxSize}/${encodeURIComponent(imageUrl)}`;
};

const getStandardThumbnailImageUrl = (baseUrl, imageUrl) => {
  return getResizedImageUrl(baseUrl, imageUrl, STANDARD_THUMBNAIL_IMAGE_SIZE);
};

const getStandardPopoverImageUrl = (baseUrl, imageUrl) => {
  return getResizedImageUrl(baseUrl, imageUrl, STANDARD_POPOVER_MAX_SIZE);
};

export const ImageResizerService = ({ baseUrl = 'https://image-resizer.shipstation.com', children, maxSize, url }) => {
  const popoverUrl = getStandardPopoverImageUrl(baseUrl, url);
  const thumbnailUrl = getStandardThumbnailImageUrl(baseUrl, url);
  const resizedUrl = maxSize ? getResizedImageUrl(baseUrl, url, maxSize) : undefined;

  return children({ popoverUrl, resizedUrl, thumbnailUrl });
};

ImageResizerService.propTypes = {
  baseUrl: PropTypes.string,
  children: PropTypes.func.isRequired,
  maxSize: PropTypes.string,
  url: PropTypes.string.isRequired,
};
